import React, { useState } from 'react';


export default function AccountHome(props) {

  let dpLogo = require("images/logos/datapulse-logo-blue-small.png");
  dpLogo = <img src={`/datapulse${dpLogo}`} />

  return (
    <div className="lite-account-home-container">
      <div className="header">
        <h1>{dpLogo}</h1>
        <h2>Real time performance tracking and reporting</h2>
        <p className="lite-home-content">Marketing has evolved and so has DataPulse. We restructured your dashboards to cut out data that isn't actionable and bring you right to the numbers that matter most. The data from all of your platforms aggregated together will tell you the whole story of whether your strategy is working or not.
          Welcome to the new streamlined experience!</p>
      </div>
      <div className="lite-account-home-footer">
        <p>Have questions? Please reach out to <a href="mailto:support@digitalposition.com" >support@digitalposition.com</a> to get in touch with an expert
        We'd love to hear your thoughts. If you have feedback to help us make DataPulse better, please fill out <a target="_blank" href="https://docs.google.com/forms/d/1Pv8WzRw-4Vv7p_JCF-UD6BahCfBen2oitu9bQF9IsNA/edit">this form</a>.</p>
      </div>
    </div>
  )
}